import {
  NameFilterBuilderOptions,
  NameFilterInput,
} from '@/shared/filters/entity-filters/name-filter-builder/name-filter-builder.types';
import { FilterBuilder } from '@/shared/filters/filter-builder';

export class NameFilterBuilder extends FilterBuilder<
  NameFilterInput,
  NameFilterBuilder
> {
  public allowedFilters: Array<keyof NameFilterInput> = ['name'];

  constructor(options?: NameFilterBuilderOptions) {
    super();

    if (options?.field) {
      this.fieldMappings = {
        name: options.field as keyof NameFilterInput,
      };
    } else if (!options?.disableFieldMapping) {
      this.fieldMappings = {
        name: 'nameLower' as keyof NameFilterInput,
      };
    }

    this.valueTransformers = {
      name: (value: string) => value.toLowerCase(),
    };
  }
}
